<template>
	<div class="qingwu">
		<el-form label-width="100px" ref="info" :rules="rules" :model="info">
			<el-form-item label="QQ群" prop="qq_group">
				<el-input type="text" placeholder="请输入QQ群号" v-model="info.qq_group"></el-input>
			</el-form-item>
			<el-form-item label="客服QQ" prop="qq">
				<el-input type="text" placeholder="请输入客服QQ" v-model="info.qq"></el-input>
			</el-form-item>
			<el-form-item label-width="160px">
				<el-button type="primary" @click="submitForm('info')">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				info: {},
				rules: {
					qq_group: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}],
					qq: [{
						required: true,
						message: "必填项请填写",
						trigger: "blur"
					}]
				}
			};
		},
		watch: {},
		computed: {},
		methods: {
			submitForm: function(e) {
				this.$refs[e].validate(res => {
					if (res) {
						// Http 请求
						this.$post(this.$api.qq_config, this.info).then(postRes => {
							if (postRes.code == 200) {
								this.$message.success("编辑成功");
								this.get_config();
							} else {
								this.$message.error("编辑失败");
							}
						});
					}
				});
			},
			get_config() {
				this.$get(this.$api.qq_config).then(res => {
					if (res.data != null) {
						this.info = res.data;
					}
				});
			},
		},
		created() {
			this.get_config();
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>

</style>